import { Formik } from 'formik';
import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

import { Box } from '@components/Box';
import {
  FormButtonsContainer,
  FormSectionContainer,
} from '@components/Container';
import { CancelLinkButton } from '@components/Form';
import { FormikInput } from '@components/Form/FormikInput';
import { Loading } from '@components/Loading';
import { routes } from '@config/routes';
import { useProductGet } from '@hooks/useProductGet';

export const ProductDetails: React.FC = () => {
  const { id } = useParams();
  const {
    product,
    isLoading: isProductLoading,
    loadData: fetchProductData,
  } = useProductGet();

  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
      fetchProductData(Number(id));
    }
  }, [id]);

  if (isProductLoading) {
    return <Loading />;
  } else {
    return (
      <>
        <Box size="medium">
          <Formik
            initialValues={product}
            validateOnBlur={true}
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            onSubmit={() => {}}
          >
            {() => {
              return (
                <>
                  <form>
                    <FormSectionContainer>
                      <FormikInput label="Name" name="name" />
                      <FormikInput label="Description" name="description" />
                      <FormikInput label="price" name="price" />
                    </FormSectionContainer>
                    <FormButtonsContainer>
                      <CancelLinkButton to={`${routes.PURCHASE_PRODUCTS}`} />
                      <button
                        className="bg-[#58993C] w-20 ml-4 rounded-md "
                        onClick={() =>
                          navigate(
                            `${routes.PURCHASE_PRODUCTS}/${product.id}/edit`
                          )
                        }
                      >
                        Edit
                      </button>
                    </FormButtonsContainer>
                  </form>
                </>
              );
            }}
          </Formik>
        </Box>
      </>
    );
  }
};
